import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState, useRef } from 'react'; 
import Skeleton from '@mui/material/Skeleton';
import { Box, createTheme, ThemeProvider, Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#E6EDF1",
          },
          "&.Mui-selected:focus": {
            backgroundColor: "#E6EDF1",
          },
          "&.MuiMenuItem-root": {
            borderBottom: "1px solid #E6EDF1",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
          // '&.Mui-selected:hover': {
          // backgroundColor: 'black',
          // },
          // '&:hover': {
          // backgroundColor: 'lightblue',
          // },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.MuiInputBase-root": {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            backgroundColor: "white",
            height: "30px",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.MuiPaper-root": {
            // overflow: "hidden",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.MuiList-root": {
            paddingTop: 0,
            maxHeight: "30vh", // Set the desired height for the list
            overflowY: "auto", // Enable vertical scrolling for the list
          },
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          "&.MuiListSubheader-root": {
            height: "32px",
            paddingLeft: 0,
            paddingRight: 0,
            borderColor: "#E6EDF1",
          },
          "&.MuiListSubheader-root:focus": {
            borderColor: "#E6EDF1",
          },
        },
      },
    },
  },
});

const RowDropdown = ({ tag, list, value, setValue, width, font ="14px", showError, disableEdit, isLoading ,isColorCoded = false, topAlignTypography=false}) =>{
  // initialize ref
  const ref = useRef();
  // set width if not given as prop
  if (width == null) {
    width = "16.6vw";
  }
  // set font size if given as prop, else use default
  let style = {};
  if (font != null) {
    style["fontSize"] = font;
  }

  // Color Codes map
  let colorCodes = {};
  if (colorCodes) {
    colorCodes["Active"] = "#008A00";
    colorCodes["Inactive"] = "#EB0000";
  }

  // function to get the color coded dropdown li
  const getColorCodedDiv = (val) => {
    return (
      <div className="d-flex justify-content-start align-items-center">
        {colorCodes[val] && (
          <Box
            sx={{
              width: 12,
              height: 12,
              bgcolor: colorCodes[val],
              borderRadius: 100,
            }}
          />
        )}
        <div className='ps-2'>{val}</div>
      </div>
    );
  };

  // event handler to set value on dropdown change
  const onDropdownChange = (e) => {
    setValue((value) => (value = e.target.value));
  };
  // handle showing error and setting focus
  const [error, setError] = useState();
  useEffect(() => {
    if (showError && showError == true) {
      // set show error
      setError((error) => (error = true));
      // focus on error element
      ref.current.focus();
    } else {
      setError((error) => (error = false));
    }
  }, [showError]);
  return (
    <>
      {isLoading ? (
        <>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={"40px"}
            sx={{ borderRadius: "5px" }}
          />
        </>
      ) : (
        <div className={topAlignTypography ? 'd-flex flex-column w-100': 'd-flex justify-content-center width-fit-content align-items-center'}>
        {/* material ui dropdown component */}
        <Typography fontSize={font} className={topAlignTypography ? "lh-24" : "align-self-center lh-24"}>
          {tag}
        </Typography>
        <ThemeProvider theme={theme}>
          <FormControl
            className={"text-start"}
            fullWidth
            size="small"
            sx={{ minWidth: width, maxWidth: width }}
          >
            <Select
              className="lh-24"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              style={style}
              onChange={(e) => onDropdownChange(e)}
            >
              {list?.map((el) => (
                <MenuItem
                  sx={{ height: "40px" }}
                  className="lh-24"
                  style={style}
                  key={el}
                  id={el}
                  value={el}
                >
                  {isColorCoded ? getColorCodedDiv(el) : el}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </ThemeProvider>
      </div>
      )}
    </>
  );
}

export default RowDropdown;